import {certissueConstants} from "../../constants";

const initialState = {
  CertIssueList: {},
  isLoading: false,
  isFailure: false,
  isDelete: false,
  isSubmit: false,
  receiverList: [],
}

export default function certissue(state = initialState, action) {
  switch (action.type) {
      /***********
       증명서 신청현황 검색조건 변경
       ************/
    case certissueConstants.CERTISSUE_SEARCH_REQUEST:
      return {
        ...state,
        selectInfo: action.payload
      }

    /*********
     증명서 신청현황 목록 조회
     **********/
    case certissueConstants.CERTISSUE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certissueConstants.CERTISSUE_SUCCESS:
      return {
        ...state,
        CertIssueList: action.response.data?.payload,
        isDelete: false,
      }
    case certissueConstants.CERTISSUE_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

      /*********
       증명서 신청현황 상세 조회
       **********/
    case certissueConstants.DETAIL_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case certissueConstants.DETAIL_SUCCESS:
      return {
        ...state,
        certissueInfo: action.response.data?.payload,
        isFailure: false
      }
    case certissueConstants.DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true
      }

    /***********
     증명서 신청현황 상세 선택
     ************/
    case certissueConstants.SELECT_REQUEST:
      return {
        ...state,
        info: action.payload
      }

      /***********
       증명서 신청현황 히스토리 관리
       ************/
    case certissueConstants.CERTISSUE_HISTORY:
      return {
        ...state,
        history: action.payload
      }

    default:
      return state
  }
}
